module.exports = __webpack_public_path__ + "img/vip1.bc4df9cf.png";